
        import {css} from 'lit-element';   
        export default css`#heading{font-size:var(--spectrum-heading-s-text-size, var(--spectrum-alias-heading-s-text-size))}`;
    